import { TQueryParam } from "../../../shared/commonTypes/commonTypes";

export const PARAMS: TQueryParam[] = ['uid', 'token'];
